export class Stage4 {
    validate() {
        // return [
        //     'current_visa_status',
        //     'visa_assistance_required',
        // ];
        
        // delegateDetails
        let dds = Alpine.store('status').currentDelegate().visa_status;
        
        
        return (
            (typeof dds.current_visa_status !== 'undefined' && dds.current_visa_status.length > 0) &&
            (typeof dds.visa_assistance_required !== 'undefined' && dds.visa_assistance_required.length > 0)
        );
    }
}